import { SortTypes } from "@mbmt-client-npm/platformtools/dist/redux/Types";
import axios from "axios";
import store from "redux/Store";
import { mlUploadLibrary, OriginTypes, pagingTotalRelation } from "redux/Types";
import { FilterOperatorTypes } from "util/table-view/TableTypes";
import { v4 as uuidv4 } from "uuid";
var module = "/uploadTrackContent/";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  // LOADING_MORE: "LOADING_MORE" + module,
  // LOAD_MORE: "LOAD_MORE" + module,
  // LOAD_NOMORE: "LOAD_NOMORE" + module,
  ERROR: "ERROR" + module,
  FOCUS_ITEM: "FOCUS_ITEM" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  QUERY: "QUERY" + module,
  ALBUM_QUERY: "ALBUM_QUERY" + module,
  EDIT_ITEM: "EDIT_ITEM" + module,
  POSTING: "POSTING" + module,
  POST_OK: "POSTOK" + module,
  POST_ERROR: "POST_ERROR" + module,
  SET_PLAYLIST: "SET_PLAYLIST" + module,
  ADD_SESSION_TRACKS: "ADD_SESSION_TRACKS" + module,
  UPDATE_OK: "UPDATE_OK" + module,
  UPDATING: "UPDATING" + module,
  UPLOADING: "UPLOADING" + module,
  SET_ALBUM_NAME: "SET_ALBUM_NAME" + module,
  REFRESH: "REFRESH" + module,
  GETTING_UPDATE_DATA: "GETTING_UPDATE_DATA" + module,
  UPDATE_DATA_OK: "UPDATE_DATA_OK" + module,
  EMPTY_ITEM: "EMPTY_ITEM" + module,
  UPLOAD_EDIT_ITEM: "UPLOAD_EDIT_ITEM" + module,
  TRACK_EDIT_ITEM: "TRACK_EDIT_ITEM" + module,
  ALBUM_OK: "ALBUM_OK" + module,
  ALBUM_EDIT_ITEM: "ALBUM_EDIT_ITEM" + module,
  ADD_TRACKS_SHOW: "ADD_TRACKS_SHOW" + module,
  REMOVE_OK: "REMOVE_OK" + module,
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.ALBUM_EDIT_ITEM,
    payload: item,
  });
};

export const addTracksShow = (status) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_TRACKS_SHOW,
    status: status,
  });
};

export const uploadEditItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.UPLOAD_EDIT_ITEM,
    payload: item,
  });
};

export const addTracksToAlbum =
  (action, message, item, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });

    axios
      .post(`${orgID}/uploads/albums/addTracksToAlbum`, item)
      .then((res) => {
        dispatch({
          type: actionTypes.ALBUM_OK,
          payload: item,
        });
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: err,
        });
        if (done) done(null, err.message || "error");
      });
  };

export const albumPost =
  (action, message, item, selectedAlbumTracks, sessionId, done = null) =>
  (dispatch) => {
    item.selectedTracks = selectedAlbumTracks;
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });

    axios
      .post(`${orgID}/uploads/session/uploadAlbum`, {
        albumdata: item,
        sessionId: sessionId,
      })
      .then((res) => {
        dispatch({
          type: actionTypes.ALBUM_OK,
          payload: item,
        });
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: err,
        });
        if (done) done(null, err.message || "error");
      });
  };

export const albumEdit =
  (action, message, item, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });

    axios
      .post(`${orgID}/uploads/session/editAlbum`, { albumdata: item })
      .then((res) => {
        dispatch({
          type: actionTypes.ALBUM_OK,
          payload: item,
        });
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: err,
        });
        if (done) done(null, err.message || "error");
      });
  };

export const saveItem =
  (items, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .post(`${orgID}/uploads/session/save`)
      .then((res) => {
        // dispatch({
        // type: actionTypes.LOAD_EDITABLE_PL,
        // payload: res?.data?.results ? res.data.results : []
        // });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
      });
  };

export const checkAndCreateAlbum =
  (item, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    const tId = uuidv4();

    axios
      .post(`${orgID}/uploads/session/checkAndCreateAlbum`, item, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        done(res.data, null);
      })
      .catch((err) => {
        done(null, err.message || "error");
      });
  };

export const trackEditItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.TRACK_EDIT_ITEM,
    payload: item,
  });
};

export const getSessionById =
  (id, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    const tId = uuidv4();

    axios
      .post(`${orgID}/uploads/session/getSessionById`, id, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        console.log(err.message);

        if (done) done(null, err.message || "error");
      });
  };

export const addSessionItems =
  (action, message, items, sessionId, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.LOAD,
      payload: items,
      sessionId: sessionId,
    });
  };

export const updateUploadTrack =
  (message, item, done = null) =>
  (dispatch) => {
    alert("REMOVE");

    const { user } = store.getState();

    //Track Setting
    var allTags = [];

    if (item.trackMetadata.org_adminTags) {
      item.trackMetadata.org_adminTags.forEach((tag) => {
        allTags.push({ Type: "BBC_ADMIN_TAG", Value: tag });
      });
    }

    if (item.trackMetadata.org_userTags) {
      item.trackMetadata.org_userTags.forEach((tag) => {
        allTags.push({ Type: `BBC_USER_TAG_${user.id}`, Value: tag });
      });
    }

    if (item.trackMetadata.org_admin_notes) {
      allTags.push({
        Type: "BBC_ADMIN_NOTES",
        Value: item.trackMetadata.org_admin_notes,
      });
    }
    item.trackMetadata.orgTags = allTags;

    //Album Setting
    var album_allTags = [];
    if (item.albumMetadata.org_album_adminTags) {
      item.albumMetadata.org_album_adminTags.forEach((tag) => {
        album_allTags.push({ Type: "BBC_ADMIN_TAG", Value: tag });
      });
    }

    if (item.albumMetadata.org_album_userTags) {
      item.albumMetadata.org_album_userTags.forEach((tag) => {
        album_allTags.push({ Type: `BBC_USER_TAG_${user.id}`, Value: tag });
      });
    }

    if (item.albumMetadata.org_album_admin_notes) {
      album_allTags.push({
        Type: "BBC_ADMIN_NOTES",
        Value: item.albumMetadata.org_album_admin_notes,
      });
    }
    item.albumMetadata.album_orgTags = album_allTags;

    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    const tId = uuidv4();
    dispatch({
      type: actionTypes.UPDATING,
      payload: message,
    });

    axios
      .post(`${orgID}/contentadmin/UpdateTrack`, item, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.UPDATE_OK,
          payload: res.data,
        });

        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: { e: err },
        });

        if (done) done(null, err);
      });
  };

export const updateTrack =
  (message, item, albumItem, isAlbumAlbum, done = null) =>
  (dispatch) => {
    const tId = uuidv4();
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    dispatch({
      type: actionTypes.UPDATING,
      payload: message,
    });

    axios
      .post(
        `${orgID}/uploads/tracks/trackUpdate`,
        { trackData: item, albumdata: albumItem, isAlbumEdit: isAlbumAlbum },
        {
          headers: { tid: tId, orgid: orgID },
        }
      )
      .then((res) => {
        dispatch({
          type: actionTypes.UPDATE_OK,
          payload: item,
        });
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        if (done) done(null, err.message || "error");
      });
  };

export const emptyItem = () => (dispatch) => {
  dispatch({
    type: actionTypes.EMPTY_ITEM,
  });
};

export const RemoveTrack =
  (message, item, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.GETTING_UPDATE_DATA,
      payload: message,
    });

    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    item.orgId = orgID;
    const tId = uuidv4();

    axios
      .post(`${orgID}/uploads/tracks/removeTrack`, item, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.UPDATE_DATA_OK,
          payload: res.data,
        });

        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: { e: err },
        });

        if (done) done(null, err);
      });
  };

export const RemoveAlbum =
  (message, item, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.GETTING_UPDATE_DATA,
      payload: message,
    });

    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    item.orgId = orgID;
    const tId = uuidv4();

    axios
      .post(`${orgID}/uploads/tracks/removeAlbum`, item, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.UPDATE_DATA_OK,
          payload: res.data,
        });

        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: { e: err },
        });

        if (done) done(null, err);
      });
  };

export const setQuery =
  (query, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.QUERY,
      payload: query,
    });

    if (typeof done === "function") {
      done();
    }
  };
  
export const albumSetQuery =
  (query, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.ALBUM_QUERY,
      payload: query,
    });

    if (typeof done === "function") {
      done();
    }
  };
export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

export const searchAlbums =
  (query, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    const tId = uuidv4();

    query.orderBy = "date_last_edited";

    dispatch({
      type: actionTypes.LOADING,
    });
    axios
      .post(`${orgID}/uploads/albums/search`, query, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
        if (done) done(res.data.results, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        if (done) done(null, err);
      });
  };

export const showAutoMessage = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.POST_OK,
    });
  }, 3000);
};

export const albumSearch =
  (query, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
      mlTrackUpdateReducer: {
        OrgOwnedLibraries,
        uploadLibId,
        showCopyAlbum,
        trackAlbumsShow,
      },
      mlSessionUploadTrackReducer: { selectedItem },
    } = store.getState();

    let tId = uuidv4();

    dispatch({
      type: actionTypes.ALBUM_QUERY,
      payload: query,
    });

    if (
      query ||
      (query && query.q) ||
      (query && query.origin !== OriginTypes.all) ||
      (query && query.filters && query.filters.length > 0) ||
      (query && query.all && query.all.q) ||
      (query && query.tagAll && query.All.q)
    ) {
      const options = {
        headers: {
          tid: tId,
        },
      };
      dispatch({
        type: actionTypes.LOADING,
      });
      let newQuery = {
        ...query,
        order: SortTypes.asc,
        orderBy: "prodName",
        qfs: ["prodName", "prodArtist"],
        filters: [...query.filters],
      };
      const libObject = OrgOwnedLibraries?.find(
        (item) => item.id === uploadLibId
      );
      let libraryId =
        trackAlbumsShow && selectedItem?.library_id != null
          ? selectedItem.library_id
          : libObject?.id;

      let workspaceId =
        trackAlbumsShow && selectedItem?.ws_id != null
          ? selectedItem?.ws_id
          : libObject?.workspace_id;

      if (libObject && !showCopyAlbum) {
        const libraryFilter = {
          operator: FilterOperatorTypes.equals,
          value: [libraryId],
          field: "libId",
        };
        const workspaceFilter = {
          operator: FilterOperatorTypes.equals,
          value: [workspaceId],
          field: "wsId",
        };

        if (libraryId === workspaceId) {
          newQuery.filters.push(workspaceFilter);
        } else {
          newQuery.filters.push(libraryFilter);
          newQuery.filters.push(workspaceFilter);
        }
      }

      axios
        .post("/albumserach", newQuery, options)
        .then((res) => {
          if (res.data.tid === tId) {
            dispatch({
              type: actionTypes.LOAD,
              payload: res.data.data,
              total: res.data.total > 10000 ? 10000 : res.data.total,
              totalRelation:
                res.data.totalRelation || pagingTotalRelation.EQUALS,
            });

            if (done) done(res.data.data, null);
          }
        })
        .catch((err) => {
          dispatch({
            type: actionTypes.ERROR,
            payload: { e: err },
          });
          if (done) done(null, err);
        });
    } else {
      dispatch({
        type: actionTypes.CLEAR,
        payload: [],
      });
    }
  };

export const search =
  (query, sessionId, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
      mlTrackUpdateReducer: { uploadLibId },
    } = store.getState();
    const tId = uuidv4();

    const myqueryFilter = [...query.filters];

    if (uploadLibId != mlUploadLibrary.EMPTY) {
      myqueryFilter.push({
        operator: FilterOperatorTypes.equals,
        value: [uploadLibId],
        field: "library_id",
      });
    } else {
      myqueryFilter.push({
        operator: FilterOperatorTypes.empty,
        value: [],
        field: "library_id",
      });
    }

    dispatch({
      type: actionTypes.LOADING,
    });
    axios
      .post(
        `${orgID}/uploads/albums/search`,
        { ...query, filters: myqueryFilter },
        {
          headers: { tid: tId, orgid: orgID },
        }
      )
      .then((res) => {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
        if (done) done(res.data.results, null);
      })
      .catch((err) => {
        console.error("Search error:", err);
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        if (done) done(null, err);
      });
  };

export const getAlbumById =
  (albumId, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    const tId = uuidv4();

    axios
      .post(`${orgID}/uploads/session/getUploadAlbumById/${albumId}`, albumId, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        if (res.data.tid === tId) {
          dispatch({
            type: actionTypes.SET_ALBUM_NAME,
            payload: res.data.results,
          });
          if (done) done(res.data.results, null);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        if (done) done(null, err);
      });
  };

export const searchAlbumTracks =
  (query, sessionId, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    query.orderBy = "id";
    if (sessionId) {
      query.filters = [
        ...query.filters,
        { field: "session_id", operator: "equals", value: [sessionId] },
      ];
    }

    const tId = uuidv4();
    dispatch({
      type: actionTypes.LOADING,
    });
    axios
      .post(`${orgID}/uploads/session/getUploadAlbumTracks`, query, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        if (res.data.tid === tId) {
          dispatch({
            type: actionTypes.LOAD,
            payload: res.data.results,
            total: res.data.total,
            totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
          });
          if (done) done(res.data.results, null);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
        if (done) done(null, err);
      });
  };
